import { serviceFetchRetailersList } from "src/api/service/services";

export const fetchAndSetRetailers = async () => {
  try {
    const response = await serviceFetchRetailersList();
    const retailersList = response.data.result;

    // Transform the response into the desired format
    const transformedRetailers = Object.keys(retailersList).reduce(
      (acc: Record<string, string>, key: string) => {
        const retailerName = retailersList[key]
          .replace(/_/g, " ") // Replace underscores with spaces
          .toLowerCase() // Convert the entire string to lowercase
          .replace(/\b\w/g, (c: string) => c.toUpperCase()); // Capitalize the first letter of each word
        acc[retailerName] = retailerName; // Set key and value both as name
        return acc;
      },
      {} as Record<string, string> // Initialize as a typed object
    );


    // Set the transformed retailers to allfilterData.retailers
    return transformedRetailers;
  } catch (error) {
    console.error("Error fetching retailers list:", error);
  }
};

export const allfilterdata = {
  // category: ["Smartphones", "Mobilephones"],
  brand: [
    "Apple",
    "Samsung",
    "OnePlus",
    "Google",
    "Xiaomi",
    "Realme",
    "Huawei",
    "Oppo",
    "Vivo",
    "Motorola",
  ],
  // dealsAndDiscount: ["All Discounts", "Today' Deals"],
  retailers: [],
  // priceRange: ["10,000", "50,000"],
  discount: [
    { "0-25": "Upto 25% off" },
    { "25-50": "25% - 50% off" },
    { "50-75": "50% - 75% off" },
    { "75-100": "More than 75% off" },
  ],
};
